import { createSelector } from '@reduxjs/toolkit'

export const featureAccessSelector = state => state.featureAccess

// Returns the full feature list array
export const featureListSelector = createSelector(
  featureAccessSelector,
  featureAccess => featureAccess.features
)

// Factory that creates a memoized selector for a specific featureCode
export const makeIsFeatureEnabledSelector = featureCode =>
  createSelector(featureListSelector, features => {
    // Find the feature entry that matches the requested featureCode
    const entry = features.find(feature => feature.featureCode === featureCode)

    // If the feature is not configured, default to disabled
    return entry ? Boolean(entry.isEnabled) : false
  })

// Non-factory convenience selector for direct usage
export const isFeatureEnabledSelector = (state, featureCode) => {
  const features = featureListSelector(state)
  const entry = features.find(feature => feature.featureCode === featureCode)

  return entry ? Boolean(entry.isEnabled) : false
}
